import { ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Inject, Injector, Input, LOCALE_ID, OnInit, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { HttpService } from '@ecp-caf/caf-common';
import { TypeConverter } from '@farris/ide-property-panel';
import { FarrisRadioGroupComponent } from '@farris/ui-forms';
import { MessagerService } from '@farris/ui-messager';
import { BsModalService } from '@farris/ui-modal';
import { NotifyService } from '@farris/ui-notify';
import { ExpressionService } from '@gsp-svc/expression';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { ProcessDeUtil } from '../../domain/process-de-util';
import { SubProcessType } from '../call-activity-sub-process/SubProcessType';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

type WfOptins = {
  subProcessType?: SubProcessType;
  calledElement?: string;
  calledBizDefKey?: string;
  calledElementName?: string;
  calledBizDefName?: string;
};

@Component({
  selector: 'lib-wf-options',
  templateUrl: './wf-options.component.html',
  styleUrls: [],
  providers: [
     WfLocalePipe,
  ]
})
export class WfOptionsComponent implements OnInit {
  @Input() editorParams: {
    bizTypeId?: string
  } = {};

  @Input() set value(v: WfOptins) {
    if (v) {
      this.entity = v;
      // 为子流程类型赋值
      if (this.entity.calledElement == null || this.entity.calledElement == "") {
        if (this.entity.calledBizDefKey == null || this.entity.calledBizDefKey == "") {
          this.entity.subProcessType = SubProcessType.Specified;
        } else {
          this.entity.subProcessType = SubProcessType.Dynamic;
        }
      } else {
        this.entity.subProcessType = SubProcessType.Specified;
      }

      this.getProcessDefKey(this.entity.calledElement);
      this.getFlowForm(this.entity.calledBizDefKey);
    }
  }
  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  modalConfig = {
    title: this.localePipe.transform("component.optins.wfOptions"),
    width: 500,
    height: 240,
    showButtons: true
  };

  readonly subProcessType = SubProcessType;

  entity: WfOptins;

  @ViewChild("radioGroupProcessType")
  radioGroupProcessType: FarrisRadioGroupComponent;
  radioGroupProcessTypeData = [
    { value: "Specified", name: this.localePipe.transform("component.optins.specified") },
    { value: "Dynamic", name: this.localePipe.transform("component.optins.dynamic") },
  ];

  constructor(
    private notify: NotifyService,
    private modalService: BsModalService,
    private message: MessagerService,
    private util: ProcessDeUtil,
    private http: HttpService,
    private designerState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private cfr: ComponentFactoryResolver,
    private inj: Injector,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }

  clickOk() {
    const obj = { value: this.entity, parameters: null };
    this.submitModal.emit(obj);
  }

  clickCancel() {
    this.closeModal.emit();
  }

  processTypeChange(val) {
    console.log(val);
    if (val == SubProcessType.Specified) {
      this.entity.calledBizDefKey = null;
      this.entity.calledBizDefName = null;
    } else if (val == SubProcessType.Dynamic) {
      this.entity.calledElement = null;
      this.entity.calledElementName = null;
    }
  }


  processConfirm(args: any) {
    if (args) {
      this.entity.calledElement = args.procDefKey;
      this.entity.calledElementName = args.name;
    }
  }

  clearProcessDef(args: any) {
    this.entity.calledElement = '';
    this.entity.calledElementName = '';
  }

  flowFormConfirm(args: any) {
    if (args) {
      this.entity.calledBizDefKey = args.id;
      this.entity.calledBizDefName = args.name;
    }
  }

  clearFlowForm(args: any) {
    this.entity.calledBizDefKey = '';
    this.entity.calledBizDefName = '';
  }

  getProcessDefKey(key: string) {
    let url = this.util.getProcessDefinitionWebApi();
    if (key) {
      url += `/procDefKey/${key}`;
      this.http.get(url).subscribe((re: any) => {
        this.entity.calledElementName = re.name;
      });
    }
  }

  getFlowForm(id: string) {
    let url = this.util.getFlowFormWebApi();
    if (id) {
      url += `/${id}`;
      this.http.get(url).subscribe((re: any) => {
        this.entity.calledBizDefName = re.name;
      });
    }
  }

}

export class WfOptionsConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any): string {
    if (data && (data.calledBizDefKey || data.calledElement)) {
      return this.localePipe.transform("component.optins.set");
    }
    return this.localePipe.transform("component.optins.notSet");
  }
}
